import React from 'react';
import { withReducer } from 'src/store/reducerLoader';
import AuthorizedSignatoryFunctional from './Components/authorised-signatory-functional';
import reducer from './reducer';
import sagas from './sagas';

const AuthorizedSignatoryPage = ({ buttonMode, buttonName, navigateDisabled }) => {
	return <AuthorizedSignatoryFunctional buttonMode={buttonMode} buttonName={buttonName} navigateDisabled={navigateDisabled} />;
};
const ReducedScreen = withReducer('authorized', reducer, sagas)(AuthorizedSignatoryPage);
export default ReducedScreen;
// export default AuthorizedSignatoryPage;
